import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { Logo } from "../../components/Logo";
import { toast } from "sonner";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#FAFAF9] grain px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo size="large" />
        </div>
        <div className="bg-white border border-gray-100 p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-10 w-10 bg-turquoise/10 flex items-center justify-center">
              <Lock className="h-4 w-4 text-turquoise" />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-light text-brand-ink">Panel Admin</h1>
              <p className="text-xs uppercase tracking-[0.2em] text-gray-400">Acceso restringido</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-bold text-brand-ink mb-3">
                Usuario
              </label>
              <input
                type="text"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                data-testid="admin-username-input"
                className="w-full bg-white border border-gray-200 px-4 py-3 text-brand-ink focus:outline-none focus:border-turquoise focus:ring-2 focus:ring-turquoise/20"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-bold text-brand-ink mb-3">
                Contraseña
              </label>
              <input
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="admin-password-input"
                className="w-full bg-white border border-gray-200 px-4 py-3 text-brand-ink focus:outline-none focus:border-turquoise focus:ring-2 focus:ring-turquoise/20"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-turquoise hover:bg-brand-turquoiseDark disabled:opacity-50 text-white px-8 py-3.5 text-sm font-medium tracking-wide transition"
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
